import { Sparkle } from "lucide-react";

const ITEMS = ["Grandpa knew.", "Old-school habit. New-school you.", "Omega-3 Fish Oil + Daily Multi", "Fish Oil · 100 softgels", "Daily Multi · 60 capsules"];

export const Marquee = ({ className = "", big = false }) => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className={`overflow-hidden whitespace-nowrap ${className}`} aria-hidden="true">
      <div className="inline-flex animate-marquee">
        {row.map((t, i) => (
          <span key={i} className={`inline-flex items-center gap-3 px-4 uppercase ${big ? "font-display text-2xl sm:text-3xl" : "font-mono tracking-widest"}`}>
            {t} <Sparkle className={big ? "h-6 w-6" : "h-3 w-3"} />
          </span>
        ))}
      </div>
    </div>
  );
};
